import { http } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('users' + params)
	},
	create(data) {
		return http.post('users', data)
	},
	update(data) {
		return http.put('users/' + data.id, data)
	},
	show(id) {
		return http.get('users/' + id)
	}
}